import { AuthService } from '../auth/auth.service';
// import {ApiStationInfoResponse, StationInfo} from '../epp/epp-types';
import { EppService } from '../epp/epp.service';
import { StationInfo, StationService } from '../shared/station.service';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

import { environment } from '../../environments/environment';

import { isNil } from '../../utils/utils';
import { colorMapping, pigeonColor } from './constants/constants';
import {
  getSunTimes,
  mosIndex,
  parameterSettings,
} from './constants/constants';
import { LngLat } from 'mapbox-gl';
import { Moment } from 'moment';
import moment from 'moment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PigeonsService {
  private http = inject(HttpClient);
  private eppService = inject(EppService);
  private auth = inject(AuthService);
  private stationService = inject(StationService);

  parameterInfo = parameterSettings;
  latestUpdateDtg: Moment;
  mosData = signal({});
  fcstHours = 192;
  private betaUrl = environment.url.bffV3;
  stationInfo = {};
  day = signal<Moment>(undefined);
  startHour = 5;
  endHour = 21;
  errorAuflassCoordinates = false;

  parameterset = 'pigeon';
  parameterDetails;
  userParametersets = {};
  defaultParametersetDetails = {};
  parameterSets = [];
  parameterNames = {};

  eppSettings = {
    previousStationId: null,
    favouriteStationId: null,
    previousParameterSet: null,
    view: null,
    parameterSets: null,
  };

  mosDataOfStation(stationId, modelRun: Moment | null = null): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const now = moment();
      const doReload: boolean = modelRun != null;
      if (doReload || !isNil(modelRun)) {
        if (this.mosData().hasOwnProperty(stationId)) {
          this.mosData.update(mosData => {
            delete mosData[stationId];
            return { ...mosData };
          });
        }
      }
      let fetchData = doReload;
      if (!this.latestUpdateDtg) {
        const storedTime = JSON.parse(
          sessionStorage.getItem('pigeons-mos-' + stationId + '-time')
        );
        if (storedTime != null) {
          this.latestUpdateDtg = moment(storedTime);
        }
      }
      if (
        !this.latestUpdateDtg ||
        now.unix() - this.latestUpdateDtg.unix() < 3600000
      ) {
        if (this.mosData().hasOwnProperty(stationId)) {
          resolve(this.mosData()[stationId]);
        } else {
          const storedData = JSON.parse(
            sessionStorage.getItem('pigeons-mos-' + stationId)
          );
          if (storedData !== null && !doReload) {
            this.mosData.update(mosData => {
              return { ...mosData, [stationId]: storedData };
            });
            resolve(this.mosData()[stationId]);
          } else {
            fetchData = true;
          }
        }
      } else {
        fetchData = true;
      }
      if (fetchData) {
        if (this.mosData().hasOwnProperty(stationId)) {
          this.mosData.update(mosData => {
            delete mosData[stationId];
            return { ...mosData };
          });
        }
        this.getData(stationId, this.fcstHours, modelRun).subscribe(
          data => {
            this.mosData.update(mosData => {
              return { ...mosData, [stationId]: { ...data } };
            });
            resolve(this.mosData()[stationId]);
          },
          err => console.log(err)
        );
      }
    });
  }

  restorePigeonRoute(routeId: string, speed: number): any {
    const storedData = JSON.parse(
      sessionStorage.getItem('pigeons-route-' + speed + '-' + routeId)
    );
    return storedData ? storedData : null;
  }

  savePigeonRoute(routeId: string, speed: number, routeDetails): void {
    sessionStorage.setItem(
      'pigeons-route-' + speed + '-' + routeId,
      JSON.stringify(routeDetails)
    );
  }

  colorMapping(parameter: string, value: number): string {
    return colorMapping(parameter, value);
  }

  pigeonColor(
    parameter: string,
    stationId: number,
    pigeonMos,
    dtgs,
    dtgIndex: number,
    indexOfHours: number
  ): string {
    return pigeonColor(
      parameter,
      stationId,
      pigeonMos,
      dtgs,
      dtgIndex,
      indexOfHours,
      this.endHour,
      this.startHour,
      this.day(),
      this.mosData()
    );
  }

  nearestStationofPosition(pos: LngLat, prevStation?): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.stationService.findStationsAroundPosition(pos).subscribe(
        data => {
          if (data.length > 0) {
            const bestStation = prevStation
              ? this.getBestStation(prevStation, data)
              : data[0];
            const station = {
              stationId: Number(bestStation.stationId),
              name: bestStation.name,
              lnglat: [
                Number(bestStation.longitude),
                Number(bestStation.latitude),
              ],
              elevation: Number(bestStation.elevation),
            };
            resolve(station);
          } else {
            reject();
          }
        },
        error => reject()
      );
    });
  }

  getStationInformation(stationId): Promise<StationInfo> {
    return new Promise((resolve, reject) => {
      if (this.stationInfo.hasOwnProperty(stationId)) {
        resolve(this.stationInfo[stationId]);
      } else {
        this.stationService.getStationInfo(stationId).subscribe(
          data => resolve(data),
          error => reject(error)
        );
      }
    });
  }

  // request start-points for individual routes
  findStartByName(searchString: string): Observable<any> {
    if (searchString.length >= 3) {
      //      const fullUrl = environment.url.bff + '/customized/pigeon/search/start/' + encodeURIComponent(searchString);
      const fullUrl =
        this.betaUrl +
        '/customized/pigeon/search/start/' +
        encodeURIComponent(searchString);
      return this.http.get(fullUrl);
    } else {
      return of([]);
    }
  }

  // request end-points for individual routes
  findDestinationByName(searchString: string): Observable<any> {
    if (searchString.length >= 3) {
      //      const fullUrl = environment.url.bff + '/customized/pigeon/search/destination/' + encodeURIComponent(searchString);
      const fullUrl =
        this.betaUrl +
        '/customized/pigeon/search/destination/' +
        encodeURIComponent(searchString);
      return this.http.get(fullUrl);
    } else {
      return of([]);
    }
  }

  mosIndex(
    stationId: number,
    hour: number,
    day: Moment,
    showCurrent = false
  ): any {
    return mosIndex(
      stationId,
      hour,
      day,
      showCurrent,
      this.day(),
      this.mosData()
    );
  }

  findAuflassortAroundPosition(lngLat: LngLat): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.errorAuflassCoordinates = false;
      this.fetchAuflassortAroundPosition(lngLat).subscribe(
        data => {
          resolve(data);
        },
        error => {
          this.errorAuflassCoordinates = true;
          console.error('findAuflassortAroundPosition', error);
        }
      );
    });
  }

  getSunTimes(lat: number, lon: number, date: Moment): any {
    return getSunTimes(lat, lon, date);
  }

  async initParameters(): Promise<void> {
    this.parameterSets = this.eppService.getParameterSets();
    this.eppService
      .getDefaultParametersetDetails(this.parameterSets)
      .then(details => {
        this.defaultParametersetDetails = details;
        this.extractParameterNames();
        this.userParametersets = {};
        if (this.eppSettings.parameterSets) {
          for (const parameterset of this.parameterSets) {
            if (this.eppSettings.parameterSets.hasOwnProperty(parameterset)) {
              this.userParametersets[parameterset] = this.checkForNewParameters(
                parameterset,
                this.eppSettings.parameterSets[parameterset]
              );
            } else {
              this.userParametersets[parameterset] = this.toUserParameterset(
                this.defaultParametersetDetails[parameterset] ?? []
              );
            }
          }
        } else {
          for (const parameterset of this.parameterSets) {
            this.userParametersets[parameterset] = this.toUserParameterset(
              this.defaultParametersetDetails[parameterset] ?? []
            );
          }
        }
      });
  }

  readEppSettings(): void {
    const storedEppSettings = localStorage.getItem('eppSettings');
    if (storedEppSettings) {
      const settings = JSON.parse(storedEppSettings);
      for (const key of Object.keys(this.eppSettings)) {
        if (settings.hasOwnProperty(key)) {
          this.eppSettings[key] = settings[key];
        }
      }
    }
  }

  toUserParameterset(parametersetDetails: any): any {
    const userParameterset = [];
    const pushedParameters = [];
    for (const detail of parametersetDetails) {
      if (pushedParameters.indexOf(detail.fe_parameter) < 0) {
        userParameterset.push({
          parameter: detail.fe_parameter,
          selected: detail.standard,
        });
        pushedParameters.push(detail.fe_parameter);
      }
    }
    return userParameterset;
  }

  saveTableSettings(settingsParameterTable, neutralColor: string): void {
    this.userParametersets[this.parameterset] = [...settingsParameterTable];
    this.eppSettings.parameterSets = this.userParametersets;
    this.saveEppSettings(neutralColor);
  }

  private getData(
    stationId: string,
    limit: number,
    modelRun?: Moment
  ): Observable<Array<any>> {
    const now = moment();
    const today =
      modelRun !== null
        ? modelRun
        : moment()
            .local()
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const day6 = today?.clone().add(6, 'days');

    // today.format('YYYY-MM-DDTHH:00:00') + 'Z', day8.format('YYYY-MM-DDTHH:00:00') + 'Z', 192)
    const startDtg = today.utc().format('YYYY-MM-DDTHH:00:00') + 'Z';
    const endDtg = day6.utc().format('YYYY-MM-DDTHH:00:00') + 'Z';
    const suffix =
      modelRun !== null
        ? '&dtgRun=' + modelRun.format('YYYY-MM-DDT00:00:00') + 'Z'
        : '';
    const addOn = '?dtgStart=' + startDtg + '&dtgEnd=' + endDtg + suffix;

    //    const url = environment.url.bff + '/customized/pigeon/' + stationId + addOn;
    const url = this.betaUrl + '/customized/pigeon/' + stationId + addOn;
    return this.http.get<any>(url).pipe(
      map(data => {
        const returnArray = [];
        let count = 0;
        if (data.hasOwnProperty('forecast')) {
          for (const dataset of data['forecast']) {
            const datasetObject: any = {};
            for (const key in dataset) {
              if (dataset.hasOwnProperty(key)) {
                const value = dataset[key];
                datasetObject[key] = value;
              }
            }
            returnArray.push(datasetObject);
            count += 1;
            if (limit && count >= limit) {
              break;
            }
          }
        }
        this.latestUpdateDtg = now;
        sessionStorage.setItem(
          'pigeons-mos-' + stationId + '-time',
          now.unix() + ''
        );
        sessionStorage.setItem(
          'pigeons-mos-' + stationId,
          JSON.stringify(returnArray)
        );
        return returnArray;
      })
    );
  }

  /* Stationen entlang der Route sollen nach Möglichkeit keinen Höhenunterschied von mehr als 300 Metern zur
     vorherigen Station haben. Das wird in einem Umkreis von max. 20 km geprüft
  */
  private getBestStation(prevStation, data): any {
    const maxElevationDifference = 300;
    const maxDistance = 20;
    const prevElevation = prevStation.elevation;
    let bestStation = data[0];
    for (const dataset of data) {
      if (
        Math.abs(Number(dataset.elevation) - prevElevation) <
        maxElevationDifference
      ) {
        if (dataset.distance < maxDistance) {
          bestStation = dataset;
          break;
        }
      }
    }
    return bestStation;
  }

  private fetchAuflassortAroundPosition(lngLat: LngLat): Observable<any> {
    //    const fullUrl = environment.url.bff + '/customized/pigeon/' + lngLat.lat + '/' + lngLat.lng;
    const fullUrl =
      this.betaUrl + '/customized/pigeon/' + lngLat.lat + '/' + lngLat.lng;
    return this.http.get<Array<any>>(fullUrl).pipe(
      map(data => {
        return data && data.length > 0 ? data[0] : null;
      })
    );
  }

  private extractParameterNames(): void {
    for (const set of this.parameterSets) {
      const names = [];
      for (const details of this.defaultParametersetDetails[set] ?? []) {
        if (names.indexOf(details.fe_parameter) < 0) {
          names.push(details.fe_parameter);
        }
      }
      this.parameterNames[set] = names;
    }
  }

  private checkForNewParameters(
    parameterset: string,
    parameters: Array<any>
  ): any {
    const checkedParameters = parameters;
    for (const detail of this.defaultParametersetDetails[parameterset] ?? []) {
      if (
        parameters.filter(p => p.parameter === detail.fe_parameter).length === 0
      ) {
        // if (parameters.indexOf(detail.fe_parameter) < 0) {
        checkedParameters.push({
          parameter: detail.fe_parameter,
          selected: detail.standard,
        });
      }
    }
    return checkedParameters;
  }

  private saveEppSettings(neutralColor: string): void {
    localStorage.setItem('eppSettings', JSON.stringify(this.eppSettings));
    const userProfile = this.auth.getUserProfile();
    if (userProfile) {
      let global = userProfile['metadata']['global'];
      if (!global) {
        global = {};
      }
      global['epp'] = this.eppSettings;
      global['eopTableColorScheme'] = neutralColor;
      this.auth.updateUserData('global', global);
    }
  }
}
